// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","disabled":"Pagination_disabled__1LE7y","active":"Pagination_active__q3h4d","rotate":"Pagination_rotate__YN9v1"};